import clsx from 'clsx'

/* blocks */
import PageHero from '@/cmp/organism/PageHero/PageHero'
import CustomerLogo from './components/CustomerLogo/CustomerLogo'
import TopTalent from './components/TopTalent/TopTalent'
import CaseStudies from './components/CaseStudies/CaseStudies'
import FeatureDropdown from '@/cmp/organism/FeatureDropdown/FeatureDropdown'
import RevenueEngine from '@/cmp/organism/RevenueEngine/RevenueEngine'
import MarketingGoals from './components/MarketingGoals/MarketingGoals'
// import ContentTypes from './components/ContentTypes/ContentTypes'
import FAQNew from '@/cmp/organism/FAQNew/FAQNew'
import FooterCta from '@/cmp/organism/FooterCta/FooterCta'

/* utils */
import { PageResponseAttributes } from '@/utils/queries/product/talent-marketplace'

/* styles */
import styles from './_.module.css'

interface Props {
  data: PageResponseAttributes
}

function TalentMarketplace({ data }: Props): JSX.Element {
  return (
    <>
      <PageHero
        class={clsx(styles.pageHero)}
        primaryHeadline={data.hero.title}
        subText={data.hero.description}
        image={data.hero.image?.data?.attributes}
        primaryCta={data.hero.primaryCta}
        secondaryCta={data.hero.secondaryCta}
        footNote={data.hero.footnote}
      />

      {data.brandList.brands.data.length > 0 ? (
        <CustomerLogo
          title={data.brandList.title}
          brands={data.brandList.brands.data.map(i => ({
            ...i.attributes.logo.data.attributes,
            alternativeText: i.attributes.name
          }))}
          brandsSecondary={data.brandListSecondary.brands.data.map(i => ({
            ...i.attributes.logo.data.attributes,
            alternativeText: i.attributes.name
          }))}
        />
      ) : null}

      <section className={clsx('font-heading text-white', styles.bgColor)}>
        <div className="container | py-8 md:py-20">
          <h2
            className={clsx(
              'text-3xl md:text-5xl text-center font-semibold | max-w-col-8 mx-auto relative',
              styles.topTitle
            )}
            dangerouslySetInnerHTML={{ __html: data.topTalentHeader }}
          />
        </div>

        {data.topTalent.multimedia?.media?.data?.attributes ? (
          <TopTalent
            title={data.topTalent.title ?? ''}
            description={data.topTalent.description ?? ''}
            image={data.topTalent.multimedia?.media?.data?.attributes}
          />
        ) : null}

        <CaseStudies
          title={data.caseStudyHeader}
          image={data.caseStudyImg.data.attributes}
          caseStudies={data.caseStudyLists.data.map(item => ({
            slug: item.attributes.slug,
            customerLogoWhite:
              item.attributes.customerLogoWhite.data.attributes,
            caseStudySquareCardBgImage:
              item.attributes.caseStudySquareCardBgImage.data.attributes,
            statisticsList: item.attributes.statisticsList
          }))}
        />
      </section>

      {data.featureListDropdown.length > 0 ? (
        <FeatureDropdown
          class={styles.accordion}
          title={data.featureTitleDropdown}
          description={data.featureDescriptionDropdown}
          image={data.featureDropdownImg.data.attributes}
          list={data.featureListDropdown.map(i => {
            return {
              id: i.id,
              title: i.title ?? '',
              description: i.description ?? '',
              media: i.multimedia?.media?.data?.attributes,
              bgColor: i.color ?? ''
            }
          })}
        />
      ) : null}

      {data.revenueEngineList.length > 0 ? (
        <RevenueEngine
          title={data.revenueEngineTitle}
          description={data.revenueEngineDescription}
          image={data.revenueEngineImg.data.attributes}
          cta={data.revenueEngineCta}
          lists={data.revenueEngineList.map(i => ({
            id: i.id,
            title: i.title ?? '',
            description: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes
          }))}
        />
      ) : null}

      {data.marketingGoalsList.length > 0 ? (
        <MarketingGoals
          title={data.marketingGoalsTitle}
          image={data.marketingGoalsImg.data.attributes}
          lists={data.marketingGoalsList.map(i => ({
            id: i.id,
            title: i.title ?? '',
            cta: i.link,
            image: i.multimedia?.media?.data?.attributes,
            color: i.color
          }))}
        />
      ) : null}

      {/* TODO: This section will be added after the assets are ready */}
      {/* {servicesWithThumbnail.length > 0 ? (
        <ContentTypes
          title={data.contentTypeTitle}
          description={data.contentTypeDescription}
          image={data.contentTypeImg.data.attributes}
          servicesList={servicesWithThumbnail.map(i => ({
            slug: i.slug,
            pageTitle: i.pageTitle,
            type: i.type,
            thumbnailImg: i.thumbnailImg
          }))}
        />
      ) : null} */}

      {data.faqs.length > 0 ? (
        <FAQNew title="Frequently asked questions" list={data.faqs} />
      ) : null}

      {data.footerCta.title ? (
        <FooterCta
          mode="full_width"
          headline={data.footerCta.title}
          primaryCta={data.footerCta.primaryCta}
          secondaryCta={data.footerCta.secondaryCta}
        />
      ) : null}
    </>
  )
}

export default TalentMarketplace
